import { CarreerPathBlockData } from "@/storyblok/schemas";
import { makeEditable } from "@/storyblok/visual-editor";
import { renderRichText } from "@storyblok/js";
import IconArrowRight from "../icons/IconArrowRight";
import IconGrowthPath1 from "../icons/IconGrowthPath1";
import IconGrowthPath2 from "../icons/IconGrowthPath2";
import IconGrowthPath3 from "../icons/IconGrowthPath3";
import { resolveSectionClasses } from "@/storyblok/resolvers";
import { Fragment } from "react";

export default function CarreerPath({ data }: { data: CarreerPathBlockData }) {
  return (
    <section
      className="section--growth-path"
      id={data.anchor}
      {...makeEditable(data)}
    >
      <div className={resolveSectionClasses(data, "container")}>
        <div className="col w33">
          <h3>{data.title}</h3>
        </div>
        <div
          className="col w66"
          dangerouslySetInnerHTML={{ __html: renderRichText(data.content) }}
        ></div>
      </div>

      <div
        className="container container-size-s growth-path-container"
        style={{ "--columns": data.steps.length }}
      >
        {data.steps.map((step, index) => (
          <Fragment key={step._uid}>
            {(() => {
              switch (index + 1) {
                case 2:
                  return (
                    <IconGrowthPath2
                      className={`icon step-${index + 1}`}
                      {...makeEditable(step)}
                    />
                  );
                case 3:
                  return (
                    <IconGrowthPath3
                      className={`icon step-${index + 1}`}
                      {...makeEditable(step)}
                    />
                  );
                default:
                  return (
                    <IconGrowthPath1
                      className={`icon step-${index + 1}`}
                      {...makeEditable(step)}
                    />
                  );
              }
            })()}
            <h4 className={`title step-${index + 1}`} {...makeEditable(step)}>
              {step.title}
            </h4>
            <p className={`text step-${index + 1}`}>{step.content}</p>
            {index + 1 < data.steps.length && (
              <div className={`hr step-${index + 1}`}>
                <hr />
                <IconArrowRight />
              </div>
            )}
          </Fragment>
        ))}
      </div>
    </section>
  );
}
